/**
 * @generated SignedSource<<c2a1a258f4114aa4585a457aa14c602f>>
 * @relayHash 3b7af7025320243494e95aee0ddedaae
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b7af7025320243494e95aee0ddedaae

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type GetAvailableDatesCapacityInput = {
  agentUserNameOrGender?: FilterByAgentUserNameOrGenderInput | null;
  appointmentType: AppointmentType;
  channel: CommunicationChannel;
  language: Language;
  licensedInCountry: Country;
  rescheduledAppointmentId?: string | null;
  service: Service;
  specialty: ServiceSpecialty;
};
export type FilterByAgentUserNameOrGenderInput = {
  agentGender: Gender;
  agentUserName?: never;
} | {
  agentGender?: never;
  agentUserName: string;
};
export type useAgentAvailableDatesForWeekQuery$variables = {
  dayOffset: number;
  input: GetAvailableDatesCapacityInput;
};
export type useAgentAvailableDatesForWeekQuery$data = {
  readonly agentAvailableDatesForWeek: ReadonlyArray<any>;
};
export type useAgentAvailableDatesForWeekQuery = {
  response: useAgentAvailableDatesForWeekQuery$data;
  variables: useAgentAvailableDatesForWeekQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dayOffset"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dayOffset",
        "variableName": "dayOffset"
      },
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "agentAvailableDatesForWeek",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAgentAvailableDatesForWeekQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useAgentAvailableDatesForWeekQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "3b7af7025320243494e95aee0ddedaae",
    "metadata": {},
    "name": "useAgentAvailableDatesForWeekQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e937667685be7b66888c9ae7e796f5a1";

export default node;
